import React from "react";
import { Star } from "lucide-react";

/**
 * StarRating — displays 5 stars with the average filled.
 *
 * Props:
 *   value: 0-5 (float)
 *   count: number of reviews (optional, shown as "(N)")
 *   size: "sm" | "md" | "lg"
 *   lang: "ar" | "en"
 */
export default function StarRating({ value = 0, count, size = "sm", lang = "ar", showCount = true }) {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  const sizes = {
    sm: { star: "w-3 h-3", text: "text-xs" },
    md: { star: "w-4 h-4", text: "text-sm" },
    lg: { star: "w-5 h-5", text: "text-base" },
  }[size] || { star: "w-3 h-3", text: "text-xs" };

  return (
    <span className={`inline-flex items-center gap-1 ${sizes.text}`} data-testid="star-rating">
      <span className="inline-flex items-center" aria-label={`${v} out of 5 stars`}>
        {[1, 2, 3, 4, 5].map((i) => {
          const fillPercent = Math.max(0, Math.min(100, (v - (i - 1)) * 100));
          return (
            <span key={i} className={`relative inline-block ${sizes.star}`}>
              <Star className={`${sizes.star} absolute inset-0 text-[#0a0a0a]/[0.15]`} />
              <span className="absolute inset-0 overflow-hidden" style={{ width: `${fillPercent}%` }}>
                <Star className={`${sizes.star} text-[#c9a55c] fill-[#c9a55c]`} />
              </span>
            </span>
          );
        })}
      </span>
      <span className="font-semibold text-[#3a3a3a]">{v.toFixed(1)}</span>
      {showCount && typeof count === "number" && (
        <span className="text-[#8a8a8a]">
          ({lang === "ar"
            ? (count === 0 ? "بدون مراجعات" : `من ${count.toLocaleString("ar-EG")} مراجعة`)
            : `${count.toLocaleString()} review${count === 1 ? "" : "s"}`})
        </span>
      )}
    </span>
  );
}
